<!--
    描述：新增租户
    日期：2021/04/06
    作者：zwh
-->
<template>
    <div>

    </div>
</template>
<script>
export default {
    name : '',
    components: {

    },
    data() {
        return {

        }
    },
    mounted() {},
    computed: {},
    watch: {},
    created() {},
    methods: {

    }
}
</script>
<style lang="less">

</style>